import React, { useEffect } from 'react';

import { CategoryFields } from '__generated__/CategoryFields';
import { Currency } from 'common/utils/currency';
import BudgetField from 'projects/components/BriefFields/BudgetField';
import TimeframeField from 'projects/components/BriefFields/TimeframeField';
import PriceGuide from 'projects/components/BudgetSlider/PriceGuide';
import ContentSetting from 'projects/components/ContentSetting';
import { ObservableForm } from 'projects/components/ObservableForm';
import { trackViewedBriefEvent } from 'projects/events';

type Fields = React.ComponentProps<typeof TimeframeField>['form']['data'] &
    React.ComponentProps<typeof BudgetField>['form']['data'] & {
        currency: string;
    };

export interface Props<T> {
    form: ObservableForm<T>;
    brief: {
        id: string;
        category: CategoryFields | null;
    };
    siteCurrency: Currency;
}

const TimeAndBudgetPage: <T extends Fields>(props: Props<T>) => React.ReactElement<Props<T>> = ({
    form,
    brief,
    siteCurrency,
}) => {
    const currency = form.get('currency') ? (form.get('currency') as Currency) : siteCurrency;

    useEffect(() => {
        trackViewedBriefEvent({
            id: brief.id,
            page: 'TimeAndBudget',
        });
    }, []);

    return (
        <ContentSetting>
            <TimeframeField form={form} />
            <BudgetField
                form={form}
                currency={currency}
                priceGuide={
                    <PriceGuide
                        min={brief.category!.priceRange[0]}
                        max={brief.category!.priceRange[1]}
                        currency={currency}
                    />
                }
            />
        </ContentSetting>
    );
};

export default TimeAndBudgetPage;
